import React, { useState, useEffect, useRef } from "react"
import { useFormikContext, FastField } from "formik"
import axios from "axios"
import { useToasts } from "react-toast-notifications"
import FormError from "../../../../formError"
import { navigate } from "gatsby"


const ProprietorInfo = ({ prevStep }) => {
   const { addToast } = useToasts()
  const { values, errors, touched, setFieldValue } = useFormikContext()
  const [identityTypes, setIdentityTypes] = useState([])
  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const inputFileRef = useRef(null)
  const identityFileRef = useRef(null)
  const [fileWarrningText, setFileWarningText] = useState("")

  const clearFileInputs = () => {
    if (inputFileRef.current) {
      inputFileRef.current.value = ""
    }
    if (identityFileRef.current) {
      identityFileRef.current.value = ""
    }
   
  }
  // const uploadImage = (file_data, file_location) => {
  //   setLoading(true)
  //   const data = new FormData()
  //   data.append("file", file_data)
  //   setFieldValue(file_location, file_data)
  //   setFieldValue(`${file_location}_name`, file_data.name)
  //   setLoading(false)
  // }
  const uploadImage = (file_data, file_location) => {
    setLoading(true)

    const myHeaders = new Headers()
    myHeaders.append("Accept", "application/json")
    myHeaders.append("token", `${localStorage.getItem("mobile_token")}`)

    const data = new FormData()
    data.append("file", file_data, file_data.name)

    axios
      .post(
        `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/web/document-upload`,
        data, // this should be the FormData object directly
        {
          headers: {
            Accept: "application/json",
            token: localStorage.getItem("mobile_token"),
          },
          redirect: "follow",
        }
      )
      .then((res) => {
        setFieldValue(file_location, res.data.data.file)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
        addToast(err.response.data.message, {
          appearance: "error",
          placement: "top-center",
          autoDismiss: true,
        })
        if (err.response.data.message === "Token expired") {
          navigate("/business-support/get-started/")
        }
        clearFileInputs()
      })
  }

  const setFile = (file, location) => {
    const maxFileSize = 5 * 1024 * 1024 // 5MB in bytes

    if (file.size > maxFileSize) {
      setFileWarningText("File size should not exceed 5MB.")
      addToast("File size should not exceed 5MB", {
        appearance: "error",
        placement: "top-center",
        autoDismiss: true,
      })
      clearFileInputs()
      setTimeout(() => setFileWarningText(""), 2000)

      return
    }
    uploadImage(file, location)
  }

  const getStates = () => {
    fetch("https://apigateway.sparkleapp.in/api/v1/kyc/states")
      .then((response) => response.json())
      .then((data) => setStates(data.data))
  }

  const getCountries = () => {
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/Countries`)
      .then((response) => response.json())
      .then((data) => {
        setCountries(data)
      })
  }

  const getIdentities = () => {
    fetch(`${process.env.DIY_BASE_URL}/api/options/v1/IdentityTypes`)
      .then((response) => response.json())
      .then((data) => {
        setIdentityTypes(data)
      })
  }

  useEffect(() => {
    getIdentities()
    getStates()
    getCountries()
  }, [])

  return (
    <>
      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="proprietor_company">
            Is the proprietor a company?
          </label>

          <FastField
            className="form-control custom-select mb-4"
            as="select"
            id="proprietor_company"
            name="proprietor_company"
          >
            <option value="">Select</option>

            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </FastField>

          <FormError
            touched={touched.proprietor_company}
            message={errors.proprietor_company}
          />
        </div>
      </div>

      {values.proprietor_company === "Yes" && (
        <div>
          <div className="form-row">
            <div className="form-group col-md-12">
              <label htmlFor="company_name">Company Name</label>
              <FastField
                type="text"
                className="form-control"
                id="company_name"
                name="company_name"
                required
              />

              <FormError
                touched={touched.company_name}
                message={errors.company_name}
              />
            </div>
          </div>
          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="rc_number">Registration Number</label>
              <FastField
                type="text"
                className="form-control"
                id="rc_number"
                name="rc_number"
                required
              />

              <FormError
                touched={touched.rc_number}
                message={errors.rc_number}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="company_country">Company Country</label>
              <FastField
                className="form-control custom-select"
                as="select"
                id="company_country"
                name="company_country"
                required
              >
                <option value="">Select Country</option>
                {countries?.map((country) => (
                  <option key={country.value} value={country.value}>
                    {country.display}
                  </option>
                ))}
              </FastField>

              <FormError
                touched={touched.company_country}
                message={errors.company_country}
              />
            </div>
          </div>

          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="company_state">Company State</label>
              <FastField
                className="form-control custom-select"
                as="select"
                id="company_state"
                name="company_state"
                required
              >
                <option value="" label="Select State">
                  Select State
                </option>
                {states?.map((data) => (
                  <option key={data.id} value={data.name}>
                    {data.name}
                  </option>
                ))}
              </FastField>

              <FormError
                touched={touched.company_state}
                message={errors.company_state}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="company_city">Company City</label>
              <FastField
                type="text"
                className="form-control"
                id="company_city"
                name="company_city"
                required
              />

              <FormError
                touched={touched.company_city}
                message={errors.company_city}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-12">
              <label htmlFor="company_address">Company Address</label>
              <FastField
                as="textarea"
                rows="3"
                className="form-control"
                id="company_address"
                name="company_address"
                required
              />

              <FormError
                touched={touched.company_address}
                message={errors.company_address}
              />
            </div>
          </div>

          <div className="form-group col-md-12">
            <label htmlFor="cac_certificate">Registration Certificate</label>
            <input
              type="file"
              className="form-control border-0"
              id="cac_certificate"
              name="cac_certificate"
              title="Accept pdf only"
              required
              ref={inputFileRef}
              onChange={(e) => setFile(e.target.files[0], "cac_certificate")}
            />

            <label
              htmlFor="cac_certificate"
              className="font-weight-light text-muted"
            >
              pdf file only
            </label>

            <FormError
              touched={touched.cac_certificate}
              message={errors.cac_certificate}
            />
          </div>

          {/* representative section starts here */}

          <div className="form-row justify-between">
            <div className="form-group col-md-12">
              <label htmlFor="representative_name">Representative Name</label>
              <FastField
                type="text"
                className="form-control"
                id="representative_name"
                name="representative_name"
                required
              />

              <FormError
                touched={touched.representative_name}
                message={errors.representative_name}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="representative_designation">
                Representative designation
              </label>
              <FastField
                type="text"
                className="form-control"
                id="representative_designation"
                name="representative_designation"
                required
              />

              <FormError
                touched={touched.representative_designation}
                message={errors.representative_designation}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="representative_country">
                Representative Country
              </label>
              <FastField
                className="form-control custom-select"
                as="select"
                id="representative_country"
                name="representative_country"
                required
              >
                <option value="">Select Country</option>
                {countries.map((country) => (
                  <option key={country.value} value={country.value}>
                    {country.display}
                  </option>
                ))}
              </FastField>

              <FormError
                touched={touched.representative_country}
                message={errors.representative_country}
              />
            </div>
          </div>

          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="representative_state">State</label>
              <FastField
                className="form-control custom-select"
                as="select"
                id="representative_state"
                name="representative_state"
                required
              >
                <option value="" label="Select State">
                  Select State
                </option>
                {states?.map((data) => (
                  <option key={data.id} value={data.name}>
                    {data.name}
                  </option>
                ))}
              </FastField>

              <FormError
                touched={touched.representative_state}
                message={errors.representative_state}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="representative_city">City</label>
              <FastField
                type="text"
                className="form-control"
                id="representative_city"
                name="representative_city"
                required
              />

              <FormError
                touched={touched.representative_city}
                message={errors.representative_city}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-md-12">
              <label htmlFor="representative_address">Address</label>
              <FastField
                as="textarea"
                rows="3"
                className="form-control"
                id="representative_address"
                name="representative_address"
                required
              />

              <FormError
                touched={touched.representative_address}
                message={errors.representative_address}
              />
            </div>
          </div>

          <div className="form-row justify-between">
            <div className="form-group col-md-5">
              <label htmlFor="representative_type">Identity Type</label>
              <FastField
                className="form-control custom-select"
                as="select"
                id="representative_type"
                name="representative_type"
                required
              >
                <option value="">Select Type</option>
                {identityTypes.map((identity) => (
                  <option key={identity.value} value={identity.value}>
                    {identity.display}
                  </option>
                ))}
              </FastField>

              <FormError
                touched={touched.representative_type}
                message={errors.representative_type}
              />
            </div>

            <div className="form-group col-md-5">
              <label htmlFor="representative_number">Identity Number</label>
              <FastField
                type="text"
                className="form-control"
                id="representative_number"
                name="representative_number"
                required
              />

              <FormError
                touched={touched.representative_number}
                message={errors.representative_number}
              />
            </div>
          </div>

          <div
            className={
              loading
                ? "progress_state form-row justify-content-center"
                : "form-row justify-content-center"
            }
          >
            <div className="form-group col-md-12">
              <label htmlFor="representative_identity">
                Representative Identity
              </label>
              <input
                type="file"
                className="form-control border-0"
                id="representative_identity"
                name="representative_identity"
                accept="image/png, image/jpeg"
                title="Accept png,jpeg file only"
                ref={identityFileRef}
                onChange={(e) =>
                  setFile(e.target.files[0], "representative_identity")
                }
              />

              <label
                htmlFor="representative_identity"
                className="font-weight-light text-muted"
              >
                jpg,png file only
              </label>

              <FormError
                touched={touched.representative_identity}
                message={errors.representative_identity}
              />
            </div>

            <p>{loading && "Uploading"}</p>
          </div>
        </div>
      )}
    </>
  )
}

export default ProprietorInfo
